import React, { useContext } from 'react'
import { Button, Modal, Text, View } from 'oio-react'
import { useRouteMatch } from 'react-router-dom'
import { PollGlyphIcon24 } from 'assets/icons'
import { useSurveyResults } from 'src/core/graphql/hooks'
import PollEditor from 'src/sites/kits/ObjectSettings/apps/PollEditor'
import ModalRoute from 'src/sites/kits/Utils/ModalRoute'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'

const PollBlock = () => {
   const match = useRouteMatch()
   const { initiative } = useContext(InitiativeHierarchyContext)
   const { surveyResults, loading } = useSurveyResults({ initiativeId: initiative.id })
   if (loading) {
      return null
   }

   const votingHasBegun = surveyResults?.[0]?.answerStats.length > 0

   return (
      <>
         <View
            padding="10px 15px"
            backgroundColor="#eee">
            <Text size="0.8" weight="medium" transform="uppercase">
               Poll
            </Text>
         </View>
         <View textAlign="center" padding="20px">
            {!initiative.appsSurveyEnabled && (
               <>
                  <Text size="1.5" color="#888">
                     {`Create a poll for this ${initiative.type.nameSingular}`}
                  </Text>
                  <View marginTop="10px">
                     <Button
                        linkTo={`${match.url}/poll`}
                        size="xs"
                        name="Create Poll"
                        color="#ddd"
                        textColor="#333"
                     />
                  </View>
               </>
            )}
            {initiative.appsSurveyEnabled && (
               <>
                  <View
                     display="inline-flex"
                     alignItems="center"
                     justifyContent="center"
                     width="40px"
                     height="40px"
                     marginBottom="10px"
                     borderRadius="50%"
                     backgroundColor="rgba(125, 60, 231, 0.1)">
                     <PollGlyphIcon24 width="18px" height="18px" color="#7d3ce7" />
                  </View>
                  <Text size="1.5" color="#888">
                     {`A poll has been created for this ${initiative.type.nameSingular}.`}
                     {votingHasBegun
                        ? ' Voting has begun. This poll can longer be edited.'
                        : ' Polls cannot be edited once voting has begun.'
                     }
                  </Text>
                  {!votingHasBegun && (
                     <View marginTop="10px">
                        <Button
                           linkTo={`${match.url}/poll`}
                           size="xs"
                           name="Edit Poll"
                           color="#ddd"
                           textColor="#333"
                        />
                     </View>
                  )}
               </>
            )}
         </View>
         <ModalRoute path={`${match.path}/poll`}>
            {({ open, onCloseComplete, onCloseTrigger }) => (
               <Modal
                  borderRadius="5px"
                  width="100%[a-b] 400px[c-f]"
                  height="100%[a] 80%[b] 95%[c] 80%[d-f]"
                  maxHeight="550px[d-f]"
                  onCloseComplete={onCloseComplete}
                  onCloseTrigger={onCloseTrigger}
                  open={open}>
                  <PollEditor
                     onCloseButtonClick={onCloseTrigger}
                     onSave={onCloseTrigger}
                  />
               </Modal>
            )}
         </ModalRoute>
      </>
   )
}

export default PollBlock
